import { isPlatformBrowser } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { inject, Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpHeadersPayload } from '../../models/utils/common.interfaces';

import { catchError, shareReplay } from 'rxjs/operators';
import { HttpRequestMethods, IDP_APPS } from '../../constants/utils';
import { EndpointKeysCommon } from '../../constants/utils/app.constants';
import { COUNTRY_LANGUAGE_FALLBACK } from '../../mocks/common/country-language-fallback';
import { CountryLanguageDetails } from '../../models/utils/country-language.interfaces';
import { ApiBuilder, AppConfigService, logError } from '../../services/utils';

@Injectable({
  providedIn: 'root'
})
export class CountryLanguageService {
  public _contentObservable!: Observable<CountryLanguageDetails>;
  config = inject(AppConfigService);
  constructor(
    private http: HttpClient,
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  private headerInfo: HttpHeadersPayload = {
    'Content-Type': 'application/json'
  };

  getCountryLanguageData(): Observable<CountryLanguageDetails> {
    if (this._contentObservable) {
      return this._contentObservable;
    } else if (isPlatformBrowser(this.platformId)) {
      this._contentObservable = this.countryLanguageDataFromAPI().pipe(
        shareReplay(1)
      );
      return this._contentObservable;
    }
    return this._contentObservable;
  }

  countryLanguageDataFromAPI(): Observable<CountryLanguageDetails> {
    return new ApiBuilder<undefined, CountryLanguageDetails>(
      this.http,
      this.config
    )
      .app(IDP_APPS.COMMON)
      .endpointKey(EndpointKeysCommon.APP_COUNTRY_LANGUAGE_URL)
      .method(HttpRequestMethods['GET'])
      .httpHeaders(this.headerInfo)
      .library('APP_COUNTRY_LANGUAGE_URL')
      .create()
      .pipe(
        catchError((error) => {
          logError(
            error,
            IDP_APPS.COMMON,
            'APP_COUNTRY_LANGUAGE_URL',
            'countryLanguageDataFromAPI'
          );
          return of(COUNTRY_LANGUAGE_FALLBACK);
        })
      );
  }
}
